//Remove session storage for graduates filter if pagetype isn't right
export const checkRemoveSessionStorage = () => {
	let data = document.querySelector('[data-pagetype]');

	let attrib = data.getAttribute('data-pagetype');

	if (attrib !== 'GraduateListPage' && attrib !== 'GraduatePage') {
		window.sessionStorage.removeItem('graduateFilter');
	}
};
